interface MailIconProps {
  size?: number;
  color?: string;
  className?: string;
}

// Mail envelope used to mark newsletter (email-fed) feeds, mirroring LockIcon's API.
const MailIcon: React.FC<MailIconProps> = ({ size = 16, color = 'currentColor', className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle', color }}
    >
      <rect x="2" y="5" width="20" height="14" rx="2.5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path
        d="M2.5 6.5 12 13l9.5-6.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MailIcon;
